import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const FooterSection = () => {
  const currentYear = new Date()?.getFullYear();

  const footerLinks = {
    platform: [
      { label: "Tableau de Bord", path: "/student-dashboard" },
      { label: "Chat IA", path: "/ai-chat-interface" },
      { label: "Quiz", path: "/interactive-quiz-system" },
      { label: "Résultats", path: "/study-field-results" }
    ],
    resources: [
      { label: "Guide d\'Orientation", path: "#" },
      { label: "Annuaire des Écoles", path: "#" },
      { label: "Blog", path: "#" },
      { label: "FAQ", path: "#" }
    ],
    company: [
      { label: "À Propos", path: "#" },
      { label: "Partenaires", path: "#" },
      { label: "Carrières", path: "#" },
      { label: "Contact", path: "#" }
    ],
    legal: [
      { label: "Conditions d\'Utilisation", path: "#" },
      { label: "Politique de Confidentialité", path: "#" },
      { label: "Mentions Légales", path: "#" }
    ]
  };

  const socialLinks = [
    { icon: "Facebook", url: "#", label: "Facebook" },
    { icon: "Twitter", url: "#", label: "Twitter" },
    { icon: "Instagram", url: "#", label: "Instagram" },
    { icon: "Linkedin", url: "#", label: "LinkedIn" }
  ];

  return (
    <footer className="bg-gray-900 text-gray-300 py-12 md:py-16">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8 md:gap-12 mb-8 md:mb-12">
          <div className="lg:col-span-2">
            <Link to="/landing-page" className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 bg-gradient-to-br from-blue-500 to-blue-700 rounded-lg flex items-center justify-center">
                <Icon name="GraduationCap" size={24} color="#FFFFFF" />
              </div>
              <span className="text-xl font-bold text-white">CURSUS Orientation</span>
            </Link>

            <p className="text-sm md:text-base text-gray-400 mb-6 leading-relaxed">
              Plateforme d'orientation académique propulsée par l'IA pour guider les étudiants sénégalais et francophones vers leur filière idéale.
            </p>

            <div className="flex gap-4">
              {socialLinks?.map((social) => (
                <a
                  key={social?.icon}
                  href={social?.url}
                  aria-label={social?.label}
                  className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-blue-600 transition-colors duration-300"
                >
                  <Icon name={social?.icon} size={20} />
                </a>
              ))}
            </div>
          </div>

          <div>
            <h3 className="text-base md:text-lg font-bold text-white mb-4">
              Plateforme
            </h3>
            <ul className="space-y-3">
              {footerLinks?.platform?.map((link) => (
                <li key={link?.label}>
                  <Link
                    to={link?.path}
                    className="text-sm md:text-base text-gray-400 hover:text-blue-400 transition-colors duration-300"
                  >
                    {link?.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-base md:text-lg font-bold text-white mb-4">
              Ressources
            </h3>
            <ul className="space-y-3">
              {footerLinks?.resources?.map((link) => (
                <li key={link?.label}>
                  <a
                    href={link?.path}
                    className="text-sm md:text-base text-gray-400 hover:text-blue-400 transition-colors duration-300"
                  >
                    {link?.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-base md:text-lg font-bold text-white mb-4">
              Entreprise
            </h3>
            <ul className="space-y-3">
              {footerLinks?.company?.map((link) => (
                <li key={link?.label}>
                  <a
                    href={link?.path}
                    className="text-sm md:text-base text-gray-400 hover:text-blue-400 transition-colors duration-300"
                  >
                    {link?.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-gray-400 text-center md:text-left">
              &copy; {currentYear} CURSUS Orientation. Tous droits réservés.
            </p>

            <div className="flex flex-wrap justify-center gap-4 md:gap-6">
              {footerLinks?.legal?.map((link) => (
                <a
                  key={link?.label}
                  href={link?.path}
                  className="text-sm text-gray-400 hover:text-blue-400 transition-colors duration-300"
                >
                  {link?.label}
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterSection;